module.exports = __webpack_public_path__ + "images/header-harmonie-muenchen-touren-54a858fe74c18b121c6e2532c6ddee0d.jpg";